import { render } from "./B2bFiltersOrdersReceived.vue?vue&type=template&id=52b6058d&scoped=true&lang=pug"
import script from "./B2bFiltersOrdersReceived.vue?vue&type=script&lang=js"
export * from "./B2bFiltersOrdersReceived.vue?vue&type=script&lang=js"

import "./B2bFiltersOrdersReceived.vue?vue&type=style&index=0&id=52b6058d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b6058d"]])

export default __exports__